import { calculateFinalPositions } from "model/Positions";
import { MatchTeams } from "model/Match/MatchTeams";
import { nonUndefined } from "Utility";
import { applyScoreOverrides, Scores } from "model/Scores";
import { mapForwardCupModeLongFormat } from "./FsForwardCupModeLongFormat";
import { FsForwardCupModeLongSet } from "db/model/match/Set/CupModeLong/Forward/FsForwardCupModeLongSet";
import { ForwardCupModeLongSet } from "model/Match/Set/CupMode/ForwardCupModeLongSet";
import { mapForwardCupModeLongTracks } from "./FsForwardCupModeLongTrack";
import {
  calculateIsCompletePlayCondition,
  calculateTrackPointBasedSetScores,
  mapMatchSetBase,
} from "../../FsMatchSet";
import { getDefinedRosterIds } from "model/Roster/Roster";

export const mapForwardCupModeLongSet = (
  fsModel: FsForwardCupModeLongSet,
  teams: MatchTeams
): ForwardCupModeLongSet | undefined => {
  if (!fsModel.format) {
    return undefined;
  }

  const format = mapForwardCupModeLongFormat(fsModel.format);
  if (!format) {
    return undefined;
  }

  const tracks = mapForwardCupModeLongTracks(
    nonUndefined(fsModel.tracks ?? []),
    teams.rosters,
    teams.scope,
    format.points,
    format.finalist,
    format.pointsLimit,
    format.driversPerTeam,
    format.requiredTeamWinners
  );

  const scores = calculateTrackPointBasedSetScores(
    tracks,
    fsModel.scoreOverrides,
    getDefinedRosterIds(teams.rosters)
  );

  applyScoreOverrides(scores, fsModel.scoreOverrides);

  const numCompleteTracks = tracks.filter((t) => t.isComplete).length;
  const isComplete =
    fsModel.overrideComplete ||
    calculateIsCompletePlayCondition(
      scores,
      format.numTracks,
      numCompleteTracks,
      format.playCondition
    );

  if (isComplete) {
    tracks.forEach((t) => (t.isComplete = true));
  }

  const results = calculateFinalPositions(isComplete, scores, compareScores);

  return {
    ...mapMatchSetBase(fsModel, isComplete, results, scores),
    format,
    tracks,
    type: "ForwardCupModeLong",
  };
};

// todo - Apply tiebreakers here
const compareScores = (scores: Scores, a: string, b: string) => {
  return scores[b] - scores[a];
};
